import { articlePackTypesSlice } from "./articlePackTypesSlice";
import * as actions from "./articlePackTypesActions";
import * as selectors from "./articlePackTypesSelectors";

export { actions };
export { selectors };
export default articlePackTypesSlice.reducer;
